const AdminStores = () => {
  return (
    <div>
      <h1>Stores</h1>
      <p>Manage Shopify store connections and configuration.</p>
    </div>
  );
};

export default AdminStores;
